"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SpecialTypeInput = /** @class */ (function (_super) {
    __extends(SpecialTypeInput, _super);
    function SpecialTypeInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { showInput: props.subTypeCode === '' };
        return _this;
    }
    SpecialTypeInput.prototype.renderType = function () {
        var _this = this;
        var specialSubType = this.props.specialSubtypes.find(function (subTypes) {
            return subTypes.code.toString() === _this.props.subTypeCode;
        });
        if (!specialSubType) {
            return null;
        }
        return (React.createElement("span", { className: "clickable", onClick: function () { return _this.setState({ showInput: true }); } }, specialSubType.description));
    };
    SpecialTypeInput.prototype.onTypeUpdated = function (specialTypeCode) {
        var specialSubType = this.props.specialSubtypes.find(function (subTypes) { return subTypes.code.toString() === specialTypeCode; });
        if (specialSubType) {
            this.props.onSubTypeChanged(specialSubType);
        }
        this.setState({ showInput: false });
    };
    SpecialTypeInput.prototype.renderInput = function () {
        var _this = this;
        return (React.createElement("select", { name: "subtypeCode", value: this.props.subTypeCode, onBlur: function () { return _this.props.subTypeCode && _this.setState({ showInput: false }); }, onChange: function (event) { return _this.onTypeUpdated(event.target.value); } },
            !this.props.subTypeCode ? React.createElement("option", { value: "" }) : null,
            this.props.specialSubtypes.map(function (specialSubType) {
                return React.createElement("option", { key: specialSubType.code, value: specialSubType.code.toString() }, specialSubType.description);
            })));
    };
    SpecialTypeInput.prototype.render = function () {
        return (React.createElement("div", { className: "subTypeInput" }, this.state.showInput ?
            this.renderInput() : this.renderType()));
    };
    return SpecialTypeInput;
}(React.Component));
exports.default = SpecialTypeInput;
